import WebSocketStore from './modules/chat/services/wsStore';

export const globalWS = new WebSocketStore();
globalWS.setMaxListeners(20);
